export default __webpack_public_path__ + "static/media/cs-a018-1.defcfcdb.svg";